{
  "#ABSATZPLAN": {
    "ACTIONS": {
      "SAVE": "Speichern",
      "KOMMENTAR": "Kommentar",
      "DELETE": "Löschen",
      "NEXT_STATUS": "Nächster Status (Weiter)",
      "PREV_STATUS": "Vorheriger Status",
      "COPY": "Kopieren",
      "ADD": "Artikel hinzufügen"
    },
    "DIALOGS": {
      "REZEPTUR_AUFLOESEN": {
        "TITLE": "Absatzplan auswählen",
        "SUBTITLE": "Bitte auf den Absatzplan klicken um die Rezepturauflösung zu starten."
      },
      "EXPORT": {
        "TITLE": "Absatzplan exportieren",
        "SUBTITLE": "Bitte wählen Sie den zu exportierenten Absatzplan mithilfe des Dropdowns aus.",
        "CANCEL_BTN": "Abbrechen",
        "SUBMIT_BTN": "Exportieren"
      },
      "KOPF_VORHANDEN": {
        "TITLE": "Offener Absatzplan gefunden",
        "SUBTITLE": "Es wurde ein nicht gespeicherter Absatzplan gefunden. Bitte wählen Sie aus, ob Sie den vorhandenen Absatzplan öffnen möchten oder den Absatzplan mit den von Ihnen ausgewählten Kriterien einlesen möchten.",
        "WARNING_HEADER": "Achtung:",
        "WARNING": "Wenn Sie \"Löschen & Einlesen\" auswählen, werden alle ungesicherten Änderungen verworfen!",
        "LOESCHEN_BTN": "Löschen & Einlesen",
        "EINLESEN_BTN": "Vorhandenen Plan öffnen"
      },
      "COPY": {
        "TITLE": "Absatzdaten kopieren",
        "SUBTITLE": "Sie können Daten von einem bestehenden Absatzplan  kopieren und in einen bestehenden Absatzplan einfügen oder alternativ direkt einen neuen Absatzplan mit den bestehenden Daten erstellen.",
        "CANCEL_BTN": "Abbrechen",
        "SUBMIT_BTN": "Absatzplan kopieren/erstellen",
        "FORM": {
          "SOURCE": {
            "LABEL": "Zu kopierende Version auswählen",
            "PLACEHOLDER": "Ursprungsversion"
          },
          "TARGET": {
            "LABEL": "Zielversion/Name",
            "PLACEHOLDER": "Zielversion/Name"
          },
          "DATUM": {
            "LABEL": "Startdatum",
            "PLACEHOLDER": "Datum"
          }
        }
      },
     "EINLESEN": {
        "TITLE": "Absatzplan einlesen",
        "SUBTITLE": "Bitte wählen Sie die erforderlichen Einstellungen aus um den Absatzplan in der von Ihnen gewünschten Aufschlüsselung und PLanvariante einzulesen.",
        "CANCEL_BTN": "Abbrechen",
        "SUBMIT_BTN": "Einlesen"
      }
    },
    "EINLESEN": {
      "TITLE": "Absatzplan einlesen"
    },
    "MENU": {
      "TITLE": "Absatzplan",
      "EINLESEN": "Einlesen",
      "QUERY": "Erstellen",
      "RESULT": "Planung"
    },
    "MESSAGES": {
      "COPY_SUCCESS": "Absatzplandaten wurden erfolgreich kopiert",
      "KOMMENTAR_SUCCESS": "Kommentar wurde erfolgreich gespeichert",
      "SAVE_SUCCESS": "Der Absatzplan wurde erfolgreich gespeichert",
      "STATUS_SUCCESS": "Der Status wurde erfolgreich auf {{status}} geändert",
      "DELETE_SUCCESS": "Der Absatzplan wurde erfolgreich gelöscht!"
    },
    "RESULT": {
      "TITLE": "Absatzplan",
      "SUBTITLE": {
        "B": "Status: Bearbeitung / Version: {{version}}",
        "P": "Status: Prüfung / Version: {{version}}",
        "F": "Status: Freigabe / Version: {{version}}"
      },
      "HEADERS": {
        "PG": "Plangruppe",
        "KUGR": "Kundengruppe",
        "KU": "Kunde",
        "ARTGR": "Artikelgruppe",
        "ART": "Artikel"
      }
    },
    "QUERY": {
      "HEADER": "Absatzplan erstellen",
      "FORM": {
        "ACTIONS": {
          "SUBMIT": "Absatzplan erstellen",
          "RESET": "Zurücksetzen"
        },
        "STARTDATUM": {
          "LABEL": "Startdatum",
          "PLACEHOLDER": "Startdatum"
        },
        "ANZAHL_MONATE": {
          "LABEL": "Anzahl der Monate",
          "PLACEHOLDER": "Anzahl der Monate"
        },
        "AUFSCHLUESSELUNG": {
          "LABEL": "Aufschlüsselung",
          "PLACEHOLDER": "Aufschlüsselung"
        },
        "PLANVARIANTE": {
          "LABEL": "Planvariante",
          "PLACEHOLDER": "Planvariante"
        },
        "VERSION": {
          "LABEL": "Version",
          "PLACEHOLDER": "Version"
        },
        "VERGLEICH_VERSION": {
          "LABEL": "Vergleichsversion",
          "PLACEHOLDER": "Vergleichsversion"
        },
        "PLANGRUPPE": {
          "LABEL": "Plangruppe",
          "PLACEHOLDER": "Plangruppe"
        },
        "KUNDENGRUPPE": {
          "LABEL": "Kundengruppe",
          "PLACEHOLDER": "Kundengruppe"
        },
        "ARTIKELGRUPPE": {
          "LABEL": "Artikelgruppe",
          "PLACEHOLDER": "Artikelgruppe"
        }
      }
    }
  }
}
